export default function StringQueryBuilder(queryObject = {}) {
    let queryString = Object.keys(queryObject)
        .filter(
            (key) =>
                queryObject[key] &&
                !(Array.isArray(queryObject[key]) && !queryObject[key].length)
        )
        .map((key) => {
            return Array.isArray(queryObject[key])
                ? queryObject[key].map((item) => `${key}=${item}`).join("&")
                : `${key}=${queryObject[key]}`;
        })
        .join("&");
    return queryString ? `?${queryString}` : "";
}
